import React from "react";
import { useDispatch } from 'react-redux'
import ReservationAction from 'redux/reservation/actions'
import SignInModal from "../app/common/SignInModal";

const SignButton = ({ render, themeColor, businessID, loading, singInPopUp }) => {
  const dispatch = useDispatch()

  const showSignIn = () => {
    dispatch({
      type: ReservationAction.SET_STATE,
      payload: {
        singInPopUp: true,
        isPopup: true,
      },
    })
  }

  return (
    <>
      {render({ showSignIn })}
      {singInPopUp && <SignInModal business_id={businessID} theme_color={themeColor} visible loading={loading} />}
    </>
  );
};

export default SignButton;
